var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.isLoaded)?_c('k-spinner',{attrs:{"height":"500px"}}):_c('nav-list-table',{attrs:{"items":_vm.navs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }